module.exports = __webpack_public_path__ + "img/pool_icon.ee1888ac.svg";